import styled from 'styled-components'
import { WHITE, RIBBON_BLUE } from 'constants/colors'
import { palette } from 'theme/palette'

export const QuickReply = styled.button<{ color?: string, isAnimation?: boolean }>`
  animation: ${({ isAnimation }) => isAnimation && '0.5s messageAnimation'};
  margin: 2px 0px 3px 5px;
  display: flex;
  justify-content: center;
  padding: 8px 16px;
  cursor: pointer;
  background: ${WHITE};
  border: 1px solid ${({ color }) => color || RIBBON_BLUE};
  color: ${({ color }) => color || RIBBON_BLUE};
  white-space: nowrap;
  box-sizing: border-box;
  border-radius: 26px;
  width: max-content;
  line-break: loose;
  user-select: none;
  line-height: 1.2;
`

export const QuickReplyContainer = styled.button.attrs(() => ({
  'data-test': 'quick-reply'
}))<{ backgroundColor: string, borderColor: string, clickedBackgroundColor: string, clickedBorderColor: string, focusBackgroundColor: string, focusBorderColor: string }>`
  background-color: ${props => props.backgroundColor};
  border: ${props => `1px solid ${props.borderColor}`};
  border-radius: 26px;
  padding: 10px;
  cursor: pointer;
  animation: .5s messageAnimation;
  height: 44px;
  min-width: 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  
  &:focus-visible {
    background-color: ${props => props.focusBackgroundColor};
    outline: 2px solid ${props => props.focusBorderColor};
  }

  &:active {
    border: ${props => `1px solid ${props.clickedBorderColor}`};
    background-color: ${props => props.clickedBackgroundColor};
  }
  
  
`

export const QuickReplyText = styled.span<{ textColor?: string }>`
  color: ${props => props.textColor || palette.mainText};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`
